/// <amd-module name="Wit/WorkItemForm/Common/HtmlUtils" />

export function htmlDecode(str: string): string {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = str;
    return textArea.value;
}
